import { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { editarCaixa } from "services/api";
// import { set } from "zod"
import 'styles/cadastrarCaixa.css'
import { paths } from "app/paths";
import { BtnVoltarHome } from "app/componentes/BtnVoltarHome";

export const EditarCaixa = () => {


    const [cod_identificacao, setCodIdentificacao] = useState("");
    const [descricao, setDescricao] = useState("");
    const [altura, setAltura] = useState<number | "">("");
    const [largura, setLargura] = useState<number | "">("");
    const [profundidade, setProfundidade] = useState<number | "">("");
    const [loading, setLoading] = useState(false);
    const [, setErro] = useState<string | null>(null);
    const [, setOk] = useState<string | null>(null);

    const navigate = useNavigate();
    const { id } = useParams<{ id: string }>();

    const idNum = useMemo(() => {
        if (!id) return NaN;
        // só aceita dígitos
        if (!/^\d+$/.test(id)) return NaN;
        return Number(id);
    }, [id]);

    useEffect(() => {
        if (Number.isNaN(idNum)) {
            setErro("ID inválido para edição de caixa.");
            // opcional: redirecionar de volta
            // navigate(paths.caixas, { replace: true });
        }
    }, [idNum, navigate]);

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setErro(null);
        setOk(null);

        if (!id) {
            setErro("ID inválido.");
            return;
        }

        const payload: any = {};
        if (cod_identificacao) payload.cod_identificacao = cod_identificacao;
        if (descricao) payload.descricao = descricao;
        if (altura) payload.altura = Number(altura);
        if (largura) payload.largura = Number(largura);
        if (profundidade) payload.profundidade = Number(profundidade);

        // Aqui você pode fazer a chamada para a API para cadastrar a caixa
        if (Object.keys(payload).length === 0) {
            setErro("Nenhuma alteração realizada.");
            return;
        }
        
        try {
            setLoading(true);
            const res = await editarCaixa(idNum, payload);
            console.log("Caixa editada com sucesso:", res.data);
            setOk("Caixa editada com sucesso!");
            navigate(paths.caixas)
        } catch (error) {
            setErro("Erro ao editar caixa: " + error);
        }finally{
            setLoading(false);
        }
    }

    return (
        <div className="cadastro-pagina" id="page-editar-caixa">
            <div className="cadastro-cartao" id="card-editar-caixa">
                <header className="cadastro-topo">
                    <h1 className="cadastro-titulo">Editar Caixa</h1>
                    <p className="cadastro-subtitulo">Preencha apenas os campos que deseja alterar.</p>
                </header>

                <form id="form-editar-caixa" className="cadastro-form duas-colunas" onSubmit={handleSubmit}>
                    <div className="cadastro-campo">
                        <label className="cadastro-rotulo" htmlFor="edit-cod">Código de Identificação</label>
                        <input
                            id="edit-cod"
                            className="cadastro-entrada"
                            type="text"
                            placeholder="Deixe em branco para manter"
                            value={cod_identificacao}
                            onChange={(e) => setCodIdentificacao(e.target.value)}
                        />
                    </div>

                    <div className="cadastro-campo">
                        <label className="cadastro-rotulo" htmlFor="edit-desc">Descrição</label>
                        <input
                            id="edit-desc"
                            className="cadastro-entrada"
                            type="text"
                            placeholder="Deixe em branco para manter"
                            value={descricao}
                            onChange={(e) => setDescricao(e.target.value)}
                        />
                    </div>

                    <div className="cadastro-campo">
                        <label className="cadastro-rotulo" htmlFor="edit-altura">Altura (cm)</label>
                        <input
                            id="edit-altura"
                            className="cadastro-entrada"
                            type="number"
                            placeholder="Deixe em branco para manter"
                            value={altura}
                            onChange={(e) => setAltura(e.target.value === "" ? "" : Number(e.target.value))}
                        />
                    </div>

                    <div className="cadastro-campo">
                        <label className="cadastro-rotulo" htmlFor="edit-largura">Largura (cm)</label>
                        <input
                            id="edit-largura"
                            className="cadastro-entrada"
                            type="number"
                            placeholder="Deixe em branco para manter"
                            value={largura}
                            onChange={(e) => setLargura(e.target.value === "" ? "" : Number(e.target.value))}
                        />
                    </div>

                    <div className="cadastro-campo">
                        <label className="cadastro-rotulo" htmlFor="edit-profundidade">Profundidade (cm)</label>
                        <input
                            id="edit-profundidade"
                            className="cadastro-entrada"
                            type="number"
                            placeholder="Deixe em branco para manter"
                            value={profundidade}
                            onChange={(e) => setProfundidade(e.target.value === "" ? "" : Number(e.target.value))}
                        />
                    </div>

                    <div className="cadastro-acoes">
                        <button id="btn-salvar" className="botao botao--primario" type="submit">
                            {loading ? "Editando..." : "Editar"}
                        </button>
                        <button
                            id="btn-voltar"
                            className="botao botao--fantasma"
                            type="button"
                            onClick={() => navigate(-1)}
                        >
                            Voltar
                        </button>
                    </div>
                </form>
            </div>
            <BtnVoltarHome />
        </div>
    );


}